module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "conditions"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "intro section"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('conditions.intro.title')))]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conditions.intro.body'))
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "tos section"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('conditions.terms.title')))]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conditions.terms.body'))
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "privacy section"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('conditions.privacy.title')))]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conditions.privacy.body'))
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fbb7028","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Conditions.vue
// module id = 119
// module chunks = 0